<template>
    <section id="form_section" class="container">
        <div class="content_header">
            <h1 class="content_header_title">Прайс - лист</h1>
            <div class="content_header_row">
                <div class="filters">
                    <div class="catalog_header">
                        <div class="catalog-sub-menu_container nav">
                            <div class="search_input_container" :class="{zindex1: isShowCatalog || modal_info || download || opensSliderModal || modal_files}">
                                <div class="search_input_block">
                                    <input class="catalog_search_input" @focus="() => {modal_info = false; overlay = true; searchResult = true; isShowCatalog = false; showGroups=[]; scrollTop() }" v-on:keyup="search()" v-model="searchval" placeholder="Пошук" />
                                    
                                    <svg v-if="!showClearInput" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                                    </svg>

                                    <svg id="close_modal" v-if="showClearInput" @click="clearSearch()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                                    </svg>
                                </div>
                                <div class="search_results" v-if="searchResult">
                                    <div class="products" v-if="searchProducts.length">
                                        <!-- <p class="cat_title" v-for="(product, key) in searchProducts" :key="key" @click.stop="expandCategoryCustom(product.id, product.name, [product.direction.code, product.group?.code, product.subgroup?.code, product.part?.code])">{{ product.name }}</p> -->
                                        <p class="cat_title" v-for="(product, key) in searchProducts" :key="key" @click.stop="getTreeByType('single_product', product.id, product.name)">{{ product.name }}</p>
                                        <p class="main_title" @click="getTreeByType('searched_products', searchval, searchval)">{{ searchTotal }} товарів співдаває </p>
                                        <template v-if="!isShowAllGroupsRes">
                                            <!-- <p class="cat_title" v-for="(group, key) in searchGroups.slice(0, 5)" :key="key" @click.stop="expandCategoryCustom(group.code, group.title + ' (' + group.products_count + ') варіантів', [group.direction.code, group.code])">{{ group.title }} ({{ group.products_count }} варіантів)</p> -->
                                            <p class="cat_title" v-for="(group, key) in searchGroups.slice(0, 5)" :key="key" @click.stop="getTreeByType('catalog_direction_groups', group.code, group.title)">{{ group.title }} ({{ group.products_count }} варіантів)</p>
                                            <a class="show_all_link" v-if="searchGroups.length > 5 && !isShowAllGroupsRes" @click="isShowAllGroupsRes = true">Переглянути усі</a>
                                        </template>
                                        <template v-else>
                                            <p class="cat_title" v-for="(group, key) in searchGroups" :key="key" @click.stop="getTreeByType('catalog_direction_groups', group.code, group.title)">{{ group.title }} ({{ group.products_count }} варіантів)</p>
                                        </template>
                                    </div>
                                    <div class="categories" v-if="searchCats.length">
                                        <p class="main_title">Категорії</p>
                                        <template v-if="!isShowAllSubGroupsRes">
                                            <p class="cat_title" v-for="(category, key) in searchCats.slice(0, 5)" :key="key" @click.stop="getTreeByType('catalog_direction_sub_groups', category.code, category.title)">{{ category.title }}</p>
                                            <a class="show_all_link" v-if="searchCats.length > 5 && !isShowAllSubGroupsRes" @click="isShowAllSubGroupsRes = true">Переглянути усі</a>
                                        </template>
                                        <template v-else>
                                            <p class="cat_title" v-for="(category, key) in searchCats" :key="key" @click.stop="getTreeByType('catalog_direction_sub_groups', category.code, category.title)">{{ category.title }}</p>
                                        </template>
                                    </div>

                                    <p class="cat_title" v-if="!searchProducts.length && !searchCats.length">Немає результатів</p>
                                </div>
                            </div>

                            <div class="sub_menu_title mobile" @click="mobileCatalog = true">
                                <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 10.5V12.5H20V10.5H0ZM0 5.5V7.5H20V5.5H0ZM0 0.5V2.5H20V0.5H0Z" fill="#356EEF"/>
                                </svg>
                                <span>Каталог товарів</span>
                                <span></span>
                            </div>

                            <div class="mobile_catalog" v-if="mobileCatalog">
                                <div class="mobile_catalog_container" v-if="!selectedMobileMenuChilds.length">
                                    <div class="mobile_catalog_container_header">
                                        <span class="mobile_catalog_main_title">Каталог товарів</span>
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="mobileCatalog = false">
                                            <g id="clear_black_24dp (4) 1">
                                            <g clip-path="url(#clip0_5494_413382)">
                                            <path id="Vector" d="M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z" fill="#356EEF"/>
                                            </g>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_5494_413382">
                                            <path d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H20.5C22.7091 0 24.5 1.79086 24.5 4V24H0.5V4Z" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </div>

                                    <!-- <span class="mobile_catalog_item" v-for="(item, key) in submenuTree.tree" :key="key" @click.stop="expandCategoryCustom(item.code, item.title, [item.code])"> -->
                                    <span class="mobile_catalog_item" v-for="(item, key) in searchTree.tree" :key="key" @click.stop="">
                                        
                                        <div class="item_title_row" @click="selectCurrentChilds(item.title, item.code, item.childs, 'catalog_direction_sub_groups')">
                                            {{ item.title }}
                                            <svg class="item_title_caret" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                            </svg>
                                        </div>

                                    </span>
                                    <span class="mobile_catalog_sub_title">Бренди</span>
                                    <span class="mobile_catalog_item" v-for="(item, key) in catalog.brands" :key="key">

                                        <div class="item_title_row" @click="selectCurrentChilds(item.title, item.code, item.groups, 'brand_catalog_direction_sub_groups')">
                                            {{ item.title }}
                                            <svg class="item_title_caret" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                            </svg>
                                        </div>

                                    </span>
                                </div>

                                <div class="mobile_catalog_container" v-else>
                                    <div class="mobile_catalog_container_header">
                                        <span class="mobile_catalog_main_title">{{ selectedMobileMenuTitle }}</span>
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="mobileCatalog = false">
                                            <g id="clear_black_24dp (4) 1">
                                            <g clip-path="url(#clip0_5494_413382)">
                                            <path id="Vector" d="M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z" fill="#356EEF"/>
                                            </g>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_5494_413382">
                                            <path d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H20.5C22.7091 0 24.5 1.79086 24.5 4V24H0.5V4Z" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </div>

                                    <div class="back_container" @click="()=>{selectedMobileMenuChilds = []; selectedMobileMenuTitle=null;}">
                                        <svg class="item_title_caret_back" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                        </svg>
                                        <span>Усі категорії</span>
                                    </div>

                                    <!-- <span class="mobile_catalog_item" v-for="(item, key) in submenuTree.tree" :key="key" @click.stop="expandCategoryCustom(item.code, item.title, [item.code])"> -->
                                    <span class="mobile_catalog_item" v-for="(group, key) in selectedMobileMenuChilds" :key="key">
                                        
                                        <div class="item_title_row" :class="{active: selectedMobileMenuExpandedSubgroups.includes(group.code)}" @click="expandMobileMenuSubgroup(group.code)">
                                            {{ group.title }}
                                            <svg class="item_title_caret_subchild" :class="{active: selectedMobileMenuExpandedSubgroups.includes(group.code)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                            </svg>
                                        </div>

                                        <template v-if="selectedMobileMenuExpandedSubgroups.includes(group.code)">
                                            <template v-if="selectedMobileMenuType === 'catalog_direction_sub_groups'">
                                                <span class="mobile_catalog_item child" v-for="(subgroup, key) in group.childs" :key="key" @click.stop="getTreeByType(selectedMobileMenuType, subgroup.code, subgroup.title); insertParam('selected_categories', [ selectedMobileMenuCode, group.code, subgroup.code])">
                                                    {{ subgroup.title }}
                                                </span>
                                            </template>
                                            <template v-if="selectedMobileMenuType === 'brand_catalog_direction_sub_groups'">
                                                <span class="mobile_catalog_item child" v-for="(subgroup, key) in group.subgroups" :key="key" @click.stop="getTreeByType('brand_catalog_direction_sub_groups', subgroup.code+'|'+selectedMobileMenuCode, subgroup.title); insertParam('selected_categories', [ selectedMobileMenuCode, group.code, subgroup.code])">
                                                    {{ subgroup.title }}
                                                </span>
                                            </template>
                                        </template>

                                    </span>
                                </div>
                            </div>

                            <div class="right_section">
                                <div class="curr_section"
                                    @focusout="toggleCurrencies = false"
                                    tabindex="0"
                                >
                                    <div
                                        class="currencies_btn"
                                        :class="{active: toggleCurrencies}"
                                        @click="() => {toggleCurrencies = !toggleCurrencies; scrollTop()}"
                                    >
                                        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 10V6C7 5.45 6.55 5 6 5H2V3H7V1H4.5V0H2.5V1H1C0.45 1 0 1.45 0 2V6C0 6.55 0.45 7 1 7H5V9H0V11H2.5V12H4.5V11H6C6.55 11 7 10.55 7 10Z" fill="#356EEF"/>
                                        <path d="M14.5895 9.51953L8.92945 15.1695L6.09945 12.3395L4.68945 13.7595L8.92945 17.9995L15.9995 10.9295L14.5895 9.51953Z" fill="#356EEF"/>
                                        </svg>
                                        <span>Валюта та ціна</span>
                                    </div>
                                    <div class="curr_container" v-if="toggleCurrencies">
                                        <span class="curr_item" v-for="(curr, key) in currencies" :key="key">{{ curr.name }} - {{ curr.value }}</span>
                                        <p class="text_titled">Валюта розрахунку</p>
                                        <div class="curr_selection">
                                            <span class="curr_name" :class="{active: selectedCurr == 'EUR'}" @click="doRecalcCurr('EUR')">EUR</span>
                                            <span class="vertical_line"></span>
                                            <span class="curr_name" :class="{active: selectedCurr == 'грн'}" @click="doRecalcCurr('грн')">ГРН</span>
                                        </div>
                                        <p class="text_titled">Урахування ПДВ</p>
                                        <div class="curr_selection">
                                            <span class="pdv_name" :class="{active: pdw}" @click="() => {pdw = true; recalculation=true; getTreeByType()}">З ПДВ</span>
                                            <span class="vertical_line"></span>
                                            <span class="pdv_name" :class="{active: !pdw}" @click="() => {pdw = false; recalculation=true; getTreeByType()}">Без ПДВ</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="download_btn" v-on:click="() => {modal_info = false; overlay = true; searchResult = false; download = true;}">
                                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 10H9V0H7V10H4L8 14L12 10ZM0 16V18H16V16H0Z" fill="#356EEF"/>
                                    </svg>
                                    <span>Завантажити</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="javascript:void(0)" v-on:click="() => {modal_info = true; overlay = true; searchResult = false;}" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
            </div>
        </div>

        <div class="content_container_row">
            <div class="content_row">
                <div class="catalog-sub-menu nav-item"
                    :class="{zindex1: searchResult || modal_info || download || opensSliderModal || modal_files}"
                    @click="() => { isShowCatalog = true; scrollTop()}"
                    tabindex="0"
                >
                    <div class="sub_menu_title">
                        <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 10.5V12.5H20V10.5H0ZM0 5.5V7.5H20V5.5H0ZM0 0.5V2.5H20V0.5H0Z" fill="#356EEF"/>
                        </svg>
                        <span>Каталог товарів</span>
                    </div>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                    </svg>

                    <div class="menu-container" v-if="isShowCatalog === true || !features_filter || features_filter.length==0">
                        <ul class="menu" v-if="submenuTree.tree">
                            <li v-for="(item, key) in submenuTree.tree" :key="key" class="menu-list-item">
                                <!-- <a href="#" class="menu-item" @click.stop="expandCategoryCustom(item.code, item.title, [item.code])"> -->
                                <a href="javascript:void(0)" class="menu-item" @click.stop="getTreeByType('catalog_directions', item.code, item.title)">
                                    <span class="menu-item-title">{{ item.title }}</span>
                                    <svg class="menu-item-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                    </svg>
                                </a>
                                <div class="groups_items">
                                    <div v-for="(chunk, i) in item.childs" :key="i">
                                        <div class="group_item" v-for="(group, key) in chunk" :key="key">
                                            <!-- <span class="group_title pb-2" @click.stop="expandCategoryCustom(group.code, group.title, [item.code, group.code])">{{ group.title }}</span> -->
                                            <span class="group_title pb-2" @click.stop="getTreeByType('catalog_direction_groups', group.code, group.title)">{{ group.title }}</span>
                                            <div class="sub_groups">
                                                <template v-if="!showGroups.includes(group.code)">
                                                    <!-- <span class="sub_group" v-for="(subgroup, key) in group.childs.slice(0, 10)" :key="key" @click.stop="expandCategoryCustom(subgroup.code, subgroup.title, [item.code, group.code, subgroup.code])">{{ subgroup.title }}</span> -->
                                                    <span class="sub_group" v-for="(subgroup, key) in group.childs.slice(0, 10)" :key="key" @click.stop="getTreeByType('catalog_direction_sub_groups', subgroup.code, subgroup.title); insertParam('selected_categories', [ item.code, group.code, subgroup.code])">{{ subgroup.title }}</span>
                                                    <span class="drop_more" v-if="group.childs.length && group.childs.length > 10" @click="expandGroup(group.code)">Переглянути усі</span>
                                                </template>
                                                <template v-else>
                                                    <!-- <span class="sub_group" v-for="(subgroup, key) in group.childs" :key="key" @click.stop="expandCategoryCustom(subgroup.code, subgroup.title, [item.code, group.code, subgroup.code])">{{ subgroup.title }}</span> -->
                                                    <span class="sub_group" v-for="(subgroup, key) in group.childs" :key="key" @click.stop="getTreeByType('catalog_direction_sub_groups', subgroup.code, subgroup.title); insertParam('selected_categories', [ item.code, group.code, subgroup.code])">{{ subgroup.title }}</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="menu-list-item brands">
                                <a href="#" class="menu-item">
                                    <span class="menu-item-title brands-title">Бренди</span>
                                </a>
                            </li>
                            <li v-for="(item, key) in submenuTree.brands" :key="key" class="menu-list-item">
                                <a href="javascript:void(0)" class="menu-item" @click.stop="getTreeByType('brand', item.id, item.title)">
                                    <span class="menu-item-title">{{ item.title }}</span>
                                    <svg class="menu-item-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                    </svg>
                                </a>
                                <div class="groups_items">
                                    <div v-for="(chunk, b) in item.groups" :key="b">
                                        <div class="group_item" v-for="(group, key) in chunk" :key="key">
                                            <!-- <span class="group_title pb-2" @click.stop="expandCategoryCustom(group.code, group.title, [group.direction.code, group.code])">{{ group.title }}</span> -->
                                            <span class="group_title pb-2" @click.stop="getTreeByType('brand_catalog_direction_groups', group.code+'|'+item.code, group.title)">{{ group.title }}</span>
                                            <div class="sub_groups">
                                                <template v-if="!showGroups.includes(group.code)">
                                                    <span href="javascript:void(0)" class="sub_group" v-for="(subgroup, key) in group.subgroups.slice(0, 10)" :key="key" @click.stop="getTreeByType('brand_catalog_direction_sub_groups', subgroup.code+'|'+item.code, subgroup.title)">{{ subgroup.title }}</span>
                                                    <span class="drop_more" v-if="group.subgroups.length && group.subgroups.length > 10" @click="expandGroup(group.code)">Переглянути усі</span>
                                                </template>
                                                <template v-else>
                                                    <span href="javascript:void(0)" class="sub_group" v-for="(subgroup, key) in group.subgroups" :key="key" @click.stop="getTreeByType('brand_catalog_direction_sub_groups', subgroup.code+'|'+item.code, subgroup.title)">{{ subgroup.title }}</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div v-if="features_filter && features_filter !== [] && features_filter !== {} && features_filter.length !==0">
                    <div class="options_container">
                        <p class="filter_header_title">Фільтри</p>
                        <div class="klema_item" v-for="(options, title) in features_filter" :key="title">
                            <div class="klema_item_dop_header" @click.prevent="dropKlemaFilters(title)" :class="{active: dopKlemaFilters.includes(title)}">
                                <h5 class="klema_sub_filter_title">{{ title }}</h5>
                                <div class="left_row">
                                    <div class="selected_filter_count" v-if="selected_klemy_filters[title] && selected_klemy_filters[title].length">
                                        <div class="clear_klema_filters" v-if="selected_klemy_filters[title] && selected_klemy_filters[title].length">
                                            <a href="javascript:void(0)" class="clear_klema_filter" @click="clearCustomKlemaFilter(title)">
                                                <span>Скинути ({{ selected_klemy_filters[title].length }})</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clip-path="url(#clip0_7317_107479)">
                                                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#356EEF"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_7317_107479">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!dopKlemaFilters.includes(title)">
                                        <g clip-path="url(#clip0_7132_52434)">
                                            <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_52434">
                                            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else>
                                        <g clip-path="url(#clip0_7038_110869)">
                                            <path d="M16.59 14.9102L12 10.3302L7.41 14.9102L6 13.5002L12 7.50016L18 13.5002L16.59 14.9102Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7038_110869">
                                            <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                            <template v-if="dopKlemaFilters.includes(title)">
                                <div v-for="(option, i) in options" :key="i"
                                    class="badge_select_value"
                                >
                                    <label>
                                        <input class="form_radio" type="checkbox" v-on:change="selectFilterKlemy(title, option)" :value="title+'|'+option" v-model="selected_klemy_filters_checkbox">
                                        <span class="sub_filter_select_title">{{ option }}</span>
                                    </label>
                                </div>
                            </template>
                        </div>

                    </div>
                </div>
            </div>


            <div class="content left">
                <div class="table_top_history" v-if="selectedType === 'catalog_direction_groups'">
                    <a href="#" class="back_filter_link_top" @click.stop="closeSearch">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.25 12H3.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10.5 5.25L3.75 12L10.5 18.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ selectedItemTitle }}
                    </a>
                    <select class="sub_group_select" v-model="sub_group_filter" @change="getTreeByType('catalog_direction_sub_groups', sub_group_filter.code, sub_group_filter.title);">
                        <option :value="null">Всі</option>
                        <option v-for="(subgroup, key) in sub_groups_filter" :key="key" :value="subgroup">{{ subgroup.title }}</option>
                    </select>
                </div>
                <div class="search_result" v-if="selectedItemTitle && is_toggle_1">
                    <div class="results_badge">
                        {{ selectedType == 'brand' ? 'Бренд: ' : '' }} {{ selectedItemTitle }} {{ '(' + totalTreeProducts + ') варіантів' }}
                        <svg @click.stop="closeSearch" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="results_badge" v-for="(selectedItem, key) in selected_klemy_filters_checkbox" :key="key">
                        {{ getFilterTitle(selectedItem) }}
                        <svg @click.stop="clearCustomFilter(selectedItem)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                        </svg>
                    </div>
                </div>
                <div class="toggle_row">
                    <div id="tree_toggle" class="toggle">
                        <div class="toggle_header" :class="{ active: is_toggle_1 }" v-on:click="toggle(1)">
                            <label class="form_label">Прайс-лист</label>

                            <svg class="cater" :class="{ active: is_toggle_1 }" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <div>
                            <table class="item_table item_table_mobile" v-if="is_toggle_1">
                                <tr>
                                    <th class="d-flex form_label" style="width: 15%; padding-left: 22px;">
                                        Артикул
                                        <svg @click.stop="sortBy('article')" class="sortable_ico" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 14.01V7H9V14.01H6L10 18L14 14.01H11ZM4 0L0 3.99H3V11H5V3.99H8L4 0Z" fill="#6C757D"/>
                                        </svg>
                                    </th>
                                    <th class="d-flex form_label" style="width: 57%; padding-left: 22px;">
                                        Найменування
                                        <svg @click.stop="sortBy('name')" class="sortable_ico" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 14.01V7H9V14.01H6L10 18L14 14.01H11ZM4 0L0 3.99H3V11H5V3.99H8L4 0Z" fill="#6C757D"/>
                                        </svg>
                                    </th>
                                    <th class="form_label" style="width: 16%; padding-left: 0px; text-align: center;">Ціна {{ selectedCurr + (selectedCurr == 'грн' ? '.' : '') }} {{ pdw ? 'з ПДВ' : 'без ПДВ'  }}</th>
                                    <th class="form_label" style="width: 12%; padding-left: 0px; text-align: center;">Наявність</th>
                                </tr>
                            </table>
                        </div>
                        <div id="toggle_content_table" class="toggle_content nested-content" :class="{active: selectedItemTitle && is_toggle_1, full_height: !is_toggle_2 && !is_toggle_3, filter_mode: selectedItemTitle}" v-if="is_toggle_1">
                            <template v-if="loadingData">
                                <span class="data-loader">
                                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                </span>
                            </template>
                            <template v-else>
                            <nested-list
                                v-if="!searchedProducts"
                                :list="listItems"
                                :sort="sortByName"
                                :direction="sortByDirection"
                                :expanded-items="expandedCategories"
                                :selected-items="selectedItems"
                            >
                                <template #item="{node, level}">
                                    <nested-item
                                        :id="node.code || node.id"
                                        :childs="node.childs"
                                        :expanded="expandedCategories.includes(node.id) || expandedCategories.includes(node.code)"
                                        :title="node.title || node.description"
                                        :article="node.article"
                                        :price="node.price"
                                        :qty="node.balance"
                                        :unit="node.unit"
                                        :product="node.name"
                                        :image="node.image"
                                        :curr="selectedCurr"
                                        :selected="selectedCategories"
                                        :productid="selectedProductId"
                                        @expand="expandCategory"
                                        @getproduct="getProduct"
                                        :level="level"
                                    >
                                    </nested-item>
                                </template>
                            </nested-list>
                            <table class="item_table" v-else>
                                <tr @click="getProduct(product.id)" class="tree_item_container product-item"  :class="{'active': selectedProductId && selectedProductId === product.id}" :id="product.id" v-for="product in searchedProducts" :key="product.id">
                                    <th class="d-flex" style="width: 15%; padding-left: 22px;height: 32px;">
                                        {{ product.article }}
                                    </th>
                                    <th class="d-flex" style="width: 57%; padding-left: 22px;height: 32px;">
                                        {{ product.description }}
                                    </th>
                                    <th style="width: 18%; padding-left: 22px; text-align: center;height: 32px;" class="ja-center">{{ product.price > 0 ? number_format(product.price, 2, ',', ' ') : 'За запитом' }}</th>
                                    <th style="width: 10%; padding-left: 12px; text-align: center;height: 32px;" class="ja-center">{{ product.balance ? product.balance + ' ' + (product.unit ? product.unit : 'шт.') : 'замовлення' }}</th>
                                </tr>
                            </table>
                            </template>
                        </div>
                    </div>
                    <!-- <div class="toggle">
                        <div class="toggle_header" :class="{ active: is_toggle_2 }" v-on:click="toggle(2)">
                            <label class="form_label">Специфікація</label>

                            <svg class="cater" :class="{ active: is_toggle_2 }" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <table class="item_table item_table_mobile" v-if="is_toggle_2">
                            <tr>
                                <th class="d-flex form_label" style="width: 3%; padding-left: 22px;"> </th>
                                <th class="d-flex form_label" style="width: 5%; padding-left: 22px;">
                                    №
                                </th>
                                <th class="d-flex form_label" style="width: 10%; padding-left: 22px;">
                                    Артикул
                                    <svg class="sortable_ico" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 14.01V7H9V14.01H6L10 18L14 14.01H11ZM4 0L0 3.99H3V11H5V3.99H8L4 0Z" fill="#6C757D"/>
                                    </svg>
                                </th>
                                <th class="d-flex form_label" style="width: 22%; padding-left: 22px;">
                                    Опис
                                    <svg class="sortable_ico" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 14.01V7H9V14.01H6L10 18L14 14.01H11ZM4 0L0 3.99H3V11H5V3.99H8L4 0Z" fill="#6C757D"/>
                                    </svg>
                                </th>
                                <th class="form_label" style="width: 10%; padding-left: 22px; text-align: center;">Кількість</th>
                                <th class="form_label" style="width: 10%; padding-left: 22px; text-align: center;">Од. вим.</th>
                                <th class="form_label" style="width: 15%; padding-left: 22px; text-align: center;">Ціна грн. без ПДВ</th>
                                <th class="form_label" style="width: 10%; padding-left: 22px; text-align: center;">Знижка</th>
                                <th class="form_label" style="width: 10%; padding-left: 22px; text-align: center;">Сума грн. без ПДВ</th>
                                <th class="form_label" style="width: 5%; padding-left: 22px; margin-right: 22px; text-align: center;">Інфо.</th>
                            </tr>
                        </table>
                        <div class="toggle_content" v-if="is_toggle_2">
                            <table class="item_table">
                                <tr class="tree_item_container product-item">
                                    <th class="d-flex" style="width: 3%; padding-left: 22px;height: 32px;">
                                        <svg width="4" height="17" viewBox="0 0 4 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 4.46094C3.1 4.46094 4 3.56094 4 2.46094C4 1.36094 3.1 0.460938 2 0.460938C0.9 0.460938 0 1.36094 0 2.46094C0 3.56094 0.9 4.46094 2 4.46094ZM2 6.46094C0.9 6.46094 0 7.36094 0 8.46094C0 9.56094 0.9 10.4609 2 10.4609C3.1 10.4609 4 9.56094 4 8.46094C4 7.36094 3.1 6.46094 2 6.46094ZM2 12.4609C0.9 12.4609 0 13.3609 0 14.4609C0 15.5609 0.9 16.4609 2 16.4609C3.1 16.4609 4 15.5609 4 14.4609C4 13.3609 3.1 12.4609 2 12.4609Z" fill="#356EEF"/>
                                        </svg>
                                    </th>
                                    <th class="d-flex" style="width: 5%; padding-left: 22px;height: 32px;">
                                    1
                                    </th>
                                    <th class="d-flex" style="width: 10%; padding-left: 22px;height: 32px;">
                                    MCSL18086R5
                                    </th>
                                    <th class="d-flex" style="width: 22%; padding-left: 22px;height: 32px;">
                                    MCSL18086R5 Шафа 1800х800х600
                                    </th>
                                    <th style="width: 10%; padding-left: 22px;height: 32px;text-align: center;display: flex;align-items: center;justify-content: center;">
                                    1
                                    </th>
                                    <th style="width: 10%; padding-left: 22px;height: 32px;text-align: center;display: flex;align-items: center;justify-content: center;">
                                        шт.
                                    </th>
                                    <th style="width: 15%; padding-left: 22px;height: 32px;text-align: center;display: flex;align-items: center;justify-content: center;">
                                        0,21
                                    </th>
                                    <th style="width: 10%; padding-left: 22px;height: 32px;text-align: center;display: flex;align-items: center;justify-content: center;">
                                        15%
                                    </th>
                                    <th style="width: 10%; padding-left: 22px;height: 32px;text-align: center;display: flex;align-items: center;justify-content: center;">
                                        0,21
                                    </th>
                                    <th style="width: 5%;text-align: center; padding-left: 22px; margin-right: 22px;height: 32px;display: flex;align-items: center;justify-content: center;">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5.96094H11V7.96094H9V5.96094ZM9 9.96094H11V15.9609H9V9.96094ZM10 0.960938C4.48 0.960938 0 5.44094 0 10.9609C0 16.4809 4.48 20.9609 10 20.9609C15.52 20.9609 20 16.4809 20 10.9609C20 5.44094 15.52 0.960938 10 0.960938ZM10 18.9609C5.59 18.9609 2 15.3709 2 10.9609C2 6.55094 5.59 2.96094 10 2.96094C14.41 2.96094 18 6.55094 18 10.9609C18 15.3709 14.41 18.9609 10 18.9609Z" fill="#356EEF"/>
                                        </svg>
                                    </th>
                                </tr>
                            </table>
                        </div>
                    </div> -->
                    <div class="toggle" v-if="!is_toggle_2">
                        <div class="toggle_header" :class="{ active: is_toggle_3 }" v-on:click="toggle(3)">
                            <label class="form_label">Картка номенклатури</label>

                            <svg class="cater" :class="{ active: is_toggle_3 }" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <div class="toggle_content description_content" v-if="is_toggle_3">
                            <div class="tabs">
                                <div class="tabs_row">
                                    <div class="tabs_row_item">
                                        <div class="tab_item" :class="{ active: is_drop_4 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=true;}">Опис</div>
                                        <div class="tab_item" :class="{ active: is_drop_1 }" v-on:click="()=> {is_drop_1=true; is_drop_2=false; is_drop_3=false;is_drop_4=false;}">Технічні характеристики</div>
                                    </div>
                                    <div class="tabs_row_item">
                                        <div class="tab_item" :class="{ active: is_drop_2 }" v-on:click="()=> {is_drop_1=false; is_drop_2=true; is_drop_3=false;is_drop_4=false;}">Аксесуари</div>
                                        <div class="tab_item" :class="{ active: is_drop_3 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=true;is_drop_4=false;}">Технічна документація</div>
                                    </div>
                                </div>
                            </div>
                            <div class="product_info_container">
                                <div class="block_main_info">
                                    <div class="block_images">
                                        <div class="main_img_container" @click="opensSliderModalAction()">
                                            <template v-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'photo'">
                                                <img :src="selectedProductMediaFiles[selectedMediaIndex].url" class="product_main_img"/>
                                            </template>
                                            <template v-else-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'video'">
                                                <iframe type="text/html"
                                                    class="product_main_img product_video_iframe"
                                                    style="width: 100%!important;"
                                                    :src="selectedProductMediaFiles[selectedMediaIndex].url"
                                                    frameborder="0"/>
                                            </template>
                                            <img v-else src="/img/no_image.png" class="product_main_img"/>

                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_4264_534856)">
                                            <rect width="18" height="18" rx="1" fill="white" fill-opacity="0.6"/>
                                            <path d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_4264_534856">
                                            <rect width="18" height="18" rx="1" fill="white"/>
                                            </clipPath>
                                            </defs>
                                            </svg>
                                        </div>
                                        <div id="modalSubItems" class="sub_images" v-if="selectedProductMediaFiles.length">
                                            <template v-for="(media, key) in selectedProductMediaFiles" :key="key">
                                                <img v-if="media.type === 'photo'" :src="media.url" @click="selectedMediaIndex = key" class="product_img" :class="{'active': selectedMediaIndex == key}"/>
                                                <!-- <iframe v-else type="text/html"
                                                    :src="media.url"
                                                    frameborder="0"/> -->
                                                <img v-else src="/img/video.png" @click="selectedMediaIndex = key" class="product_img" :class="{'active': selectedMediaIndex == key}"/>
                                            </template>
                                        </div>
                                        <div class="sub_images" v-else>
                                            <img src="/img/no_image.png" class="product_img"/>
                                            <img src="/img/no_image.png" class="product_img"/>
                                            <img src="/img/no_image.png" class="product_img"/>
                                        </div>
                                    </div>
                                    <template v-if="selectedProduct">
                                    <p class="product_info_text">Артикул: {{ selectedProduct.article }}</p>
                                    <p class="product_info_text">Опис: {{ selectedProduct.description }}</p>
                                    </template>
                                </div>
                                <div class="block_info">
                                    <div class="info_list">
                                        <template v-if="is_drop_4">
                                            <div class="info_list_content">
                                                <div v-html="selectedProductDescription"></div>
                                            </div>
                                        </template>

                                        <template v-if="is_drop_1">
                                            <div class="info_list_content">
                                                <div class="info_list_item" v-for="(feature, key) in selectedProductFeatures" :key="key">
                                                    <template v-if="feature.value && feature.value !== ''">
                                                        <p class="info_list_item_title">{{ feature.title }}:</p>
                                                        <p class="info_list_item_value">{{ feature.value }} {{ feature.unit && feature.unit !== '-' ? feature.unit : '' }}</p>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-if="is_drop_2">
                                            <div class="info_list_content table_container">
                                                <table class="item_table self_table" v-if="is_toggle_1">
                                                    <tr>
                                                        <th class="d-flex form_label" style="width: 15%; padding-left: 22px;font-weight: 500;">
                                                            Артикул
                                                        </th>
                                                        <th class="d-flex form_label" style="width: 57%; padding-left: 22px;font-weight: 500;">
                                                            Опис
                                                        </th>
                                                        <th class="form_label" style="width: 16%; padding-left: 0px; text-align: center;font-weight: 500;">Ціна {{ selectedCurr + (selectedCurr == 'грн' ? '.' : '') }} {{ pdw ? 'з ПДВ' : 'без ПДВ'  }}</th>
                                                        <th class="form_label" style="width: 12%; padding-left: 0px; text-align: center;font-weight: 500;">Наявність</th>
                                                    </tr>
                                                </table>
                                                <nested-list
                                                    :list="selectedProductAccesories"
                                                    :sort="null"
                                                    :direction="'asc'"
                                                    :expanded-items="itemExpandedCategories"
                                                    :selected-items="itemSelectedItems"
                                                >
                                                    <template #item="{node, level}">
                                                        <nested-item
                                                            :id="node.code || node.id"
                                                            :childs="node.childs"
                                                            :expanded="itemExpandedCategories.includes(node.id) || itemExpandedCategories.includes(node.code)"
                                                            :title="node.title || node.description"
                                                            :article="node.article"
                                                            :price="node.price"
                                                            :qty="node.leave_rate"
                                                            :unit="node.unit"
                                                            :product="node.name"
                                                            :image="node.image"
                                                            :curr="selectedCurr"
                                                            :selected="itemSelectedCategories"
                                                            @expand="itemExpandCategory"
                                                            :level="level"
                                                        >
                                                        </nested-item>
                                                    </template>
                                                </nested-list>
                                            </div>
                                        </template>
                                            
                                        <template v-if="is_drop_3">
                                            <div class="info_list_content">

                                                <div class="row_file" v-for="(media, key) in selectedProductFiles" :key="key">
                                                    <span class="modal_file_name">{{ key }}</span>
                                                    <span class="underline"></span>
                                                    <div class="docs_row">
                                                        <a v-for="(file, i) in media" :key="i" :href="file.file" target="_blank" class="modal_file_link">
                                                            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M2 0C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0H2ZM9 7V1.5L14.5 7H9Z" fill="#356EEF"/>
                                                            </svg>
                                                            {{ file.ext }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <a href="javascript:void(0)" class="download_all_btn" v-if="Object.entries(selectedProductFiles).length" v-on:click="modal_files = true">
                                                <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                                </svg>
                                                Скачати все
                                            </a>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="toggle">
                        <div class="toggle_header" :class="{ active: is_toggle_2 }" v-on:click="toggle(2)">
                            <label class="form_label">Сконфігурована специфікація</label>

                            <svg class="cater" :class="{ active: is_toggle_2 }" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <div class="toggle_content description_content" v-if="is_toggle_2"></div>
                    </div>

                    <div class="toggle" v-if="is_toggle_2">
                        <div class="toggle_header" v-on:click="toggle(3)">
                            <label class="form_label">Картка номенклатури</label>

                            <svg class="cater" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z" fill="#356EEF"/>
                            </svg>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="overlay" v-if="overlay || isShowCatalog || modal_files" v-on:click="() => {download = false; modal_info = false; overlay = false; isShowCatalog = false; searchResult = false; opensSliderModal=false; modal_files = false; showGroups=[]; deleteParam(['categories'])}"></div>
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="() => {modal_info = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-if="text" v-html="text"></div>
                <div class="modal_content" v-else>Прайс - лист</div>
            </div>
        </div>
        <div class="modal files_modal" v-if="modal_files">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Обрати файли для завантажування</p>
                    <svg id="close_modal" v-on:click="() => {modal_files = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content">
                    <div class="line_switcher">
                        <label class="toggle">
                            <input class="toggle__checkbox" type="checkbox" v-model="isSelectFileAllTreeItem" v-on:change="selectFileAllTreeItem(key)">
                            <span class="toggle__switch"></span>
                            <span class="title">Усі</span>
                        </label>

                        <div class="checkbox_tree">
                            <div class="checkbox_tree_item" v-for="(media, key) in selectedProductFiles" :key="key">
                                <div class="checkbox_tree_header">
                                    <label class="form_label">
                                        <input value="1" type="checkbox" :indeterminate.prop="preCheckedFiles.includes(key)" :checked="selectedTreeItems.includes(key)" class="form_radio" v-on:change="selectFileAllTreeItem(key)">
                                        <span class="selected_value">{{ key }}</span>
                                    </label>
                                    <svg v-on:click="expandFileTree(key)" :class="{'expanded' : expandedTreeItems.includes(key)}" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.91 7.91016L6.5 3.33016L11.09 7.91016L12.5 6.50016L6.5 0.500156L0.5 6.50016L1.91 7.91016Z" fill="#356EEF"/>
                                    </svg>
                                </div>

                                <div class="checkbox_tree_body" v-if="expandedTreeItems.includes(key)">
                                    <label class="form_label" v-for="(file, i) in media" :key="i">
                                        <input :value="file.ext" type="checkbox" :checked="selectedTreeItems.includes(key+'|'+i)" class="form_radio" v-on:change="selectFileTreeItem(key, i)">
                                        <span class="selected_value">{{ file.ext }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal_content_footer">
                    <span class="modal_content_footer_subtitle">Кількість файлів - {{ filesCount() }} шт. ({{ formatBytes(totalFilesSize) }})</span>
                    <a href="javascript:void(0)" class="modal_content_footer_btn" v-on:click="downloadFiles()" v-if="!fileownloading">
                        Завантажити
                    </a>
                    <a href="javascript:void(0)" class="modal_content_footer_btn" v-else>
                        Завантаження..
                    </a>
                </div>
            </div>
        </div>
        <div class="modal product_media_modal" v-if="opensSliderModal">
            <div class="modal_container">
                <svg id="close_modal" v-on:click="() => {opensSliderModal = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
                <div class="modal_content">
                    <div class="product_media_modal_main_img_container">
                        <template v-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'photo'">
                            <img :src="selectedProductMediaFiles[selectedMediaIndex].url" class="product_media_modal_main_img"/>
                        </template>
                        <template v-else-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'video'">
                            <iframe type="text/html"
                                class="product_media_modal_main_img"
                                :src="selectedProductMediaFiles[selectedMediaIndex].url"
                                frameborder="0"/>
                        </template>
                        <img v-else src="/img/no_image.png" class="product_media_modal_main_img"/>

                        <div class="group_btns">
                            <a href="javascript:void(0)" @click="()=> {selectedMediaIndex > 0 ? selectedMediaIndex-- : selectedMediaIndex}">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="#356EEF"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" @click="modalNextMedia()">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.0898437 1.41L4.66984 6L0.0898437 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898437 1.41Z" fill="#356EEF"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div class="product_media_modal_sub_images" v-if="selectedProductMediaFiles.length">
                        <template v-for="(media, key) in selectedProductMediaFiles" :key="key">
                            <img v-if="media.type === 'photo'" :src="media.url" @click="selectedMediaIndex = key" class="product_media_modal_img" :class="{'active': selectedMediaIndex == key}"/>
                            <img v-else src="/img/video.png" @click="selectedMediaIndex = key" class="product_media_modal_img" :class="{'active': selectedMediaIndex == key}"/>
                        </template>
                    </div>
                    <div class="product_media_modal_sub_images" v-else>
                        <img src="/img/no_image.png" class="product_media_modal_img"/>
                        <img src="/img/no_image.png" class="product_media_modal_img"/>
                        <img src="/img/no_image.png" class="product_media_modal_img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal download_modal" v-if="download">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Завантажити документацію</p>
                    <svg id="close_modal" v-on:click="() => {download = false; modal_info = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content">
                    <div class="row_file">
                        <span class="modal_file_name">Прайс лист</span>
                        <span class="underline"></span>
                        <a href="#" @click="downloadPriceList()" class="modal_file_link" style="padding-left:20px;" v-if="!isDownloadPriceList">
                            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 0C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0H2ZM9 7V1.5L14.5 7H9Z" fill="#356EEF"/>
                            </svg>
                            xlsx
                        </a>
                        <span class="modal_file_loading" v-else>Завантаження..</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import PriceListLayout from "@/Layouts/PriceListLayout";
import Tooltip from 'primevue/tooltip';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/tree';
import NestedList from "./NestedList/NestedList.vue";
import NestedItem from "./NestedList/NestedItem.vue";
import { nextTick } from 'vue'

export default {
    props: {
        text: {
            type: String,
            required: false,
        },
        file: {
            type: String,
            required: false,
        },
    },

    directives: {
        Tooltip,
    },
    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        TreeTable,
        Tree,
        NestedList,
        NestedItem,
    },
    layout: PriceListLayout,
    data() {
        return {
            modal_info: false,
            modal_files: false,
            download: false,
            overlay: false,
            is_toggle_1: true,
            is_toggle_2: false,
            is_toggle_3: false,
            catalog: [],
            hoveredBrand: null,
            searchval: null,
            fileownloading: false,

            opensSliderModal: false,

            loadingData: false,
            
            recalculation: false,

            totalTreeProducts: 0,

            submenuTree: [],
            searchTree: [],

            expandedCategories: [],
            selectedCategories: [],

            selectedKey: null,
            expandedKeys: {},

            itemExpandedCategories: [],
            itemSelectedCategories: [],

            showGroups: [],

            searchProducts: [],
            searchGroups: [],
            searchCats: [],
            searchTotal: 0,
            searchResult: false,
            isShowAllGroupsRes: false,
            isShowAllSubGroupsRes: false,
            isShowCatalog: false,

            selectedItems: null,
            selectedItemTitle: null,

            sortByName: null,
            sortByDirection: 'asc',

            searchedProducts: null,

            selectedCurr: 'грн',
            pdw: true,
            currencies: [],
            toggleCurrencies: false,

            mobileCatalog: false,

            selectedType: null,
            selectedCode: null,
            selectedTitle: null,

            is_drop_1: false,
            is_drop_2: false,
            is_drop_3: false,
            is_drop_4: true,

            showClearInput: false,
            isDownloadPriceList: false,

            selectedProductId: null,
            selectedProduct: null,
            selectedProductPhotos: [],
            selectedProductVideos: [],
            selectedProductDescription: null,
            selectedProductAccesories: [],
            selectedProductFeatures: [],
            selectedProductMediaFiles: [],
            selectedProductFiles: [],

            expandedTreeItems: [],
            selectedTreeItems: [],
            preCheckedFiles: [],
            selectedFiles: {
                '2-D Креслення': [],
                'Інструкція': [],
                'Сертифікат': [],
            },

            selectedTreeItemsOld: [],
            selectedFilesOld: {
                '2-D Креслення': [],
                'Інструкція': [],
                'Сертифікат': [],
            },
            preCheckedFilesOld: [],

            selectedMediaIndex: 0,
            isSelectFileAllTreeItem: true,

            totalFilesSize: 0,

            selectedMobileMenuTitle: null,
            selectedMobileMenuType: null,
            selectedMobileMenuCode: null,
            selectedMobileMenuChilds: [],
            selectedMobileMenuExpandedSubgroups: [],

            features_filter: [],
            sub_groups_filter: [],
            dopKlemaFilters: [],
            selected_klemy_filters: {},
            selected_klemy_filters_checkbox: [],
            sub_group_filter: null,
        }
    },

    beforeMount () {
        window.addEventListener('keydown', this.handleKeydown, null);
    },

    mounted() {
        this.getCurr();

        // get url get params
        let uri = window.location.search.substring(1); 
        let params = new URLSearchParams(uri);

        if (params.has("selected_type")) {
            this.selectedType = params.get("selected_type");
            this.selectedCode = params.get("selected_code");
            this.selectedTitle = params.get("selected_title");
            this.selectedItemTitle = params.get("selected_item_title");
            this.totalTreeProducts = params.get("selected_products");
        }
    },

    beforeDestroy () {
        window.removeEventListener('keydown', this.handleKeydown);
    },

    computed: {
        listItems() {
            if (this.sortByName) {
                this.sortNodes(this.catalog.tree, this.expandedCategories, this.sortByName, this.sortByDirection)
            }

            return this.catalog.tree
        }
    },

    methods: {
        insertParam(name, value) {
            const params = new URLSearchParams(window.location.search);
            params.set(name, value);
            window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
        },
        deleteParam(names) {
            names.forEach((name, index) => {
                const params = new URLSearchParams(window.location.search);
                params.delete(name);
                window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
            });
        },
        selectFileAllTreeItem (key) {
            if (key) {
                // expand by parent
                if (!this.selectedTreeItems.includes(key)) {
                    this.selectedTreeItems.push(key)
                    let files = this.selectedProductFiles[key];

                    if (!this.selectedFiles[key]) {
                        this.selectedFiles[key] = []
                    }

                    for (const [i, value] of Object.entries(files)) {

                        if (!this.selectedFiles[key].includes(value.file)) {
                            this.selectedFiles[key].push(value.file)
                        }

                        if (!this.selectedTreeItems.includes(key+'|'+i)) {
                            this.selectedTreeItems.push(key+'|'+i)
                        }
                    }
                } else {
                    const index = this.selectedTreeItems.indexOf(key);
                    if (index > -1) {
                        this.selectedTreeItems.splice(index, 1);

                        let files = this.selectedProductFiles[key];
                        for (const [i, value] of Object.entries(files)) {

                            if (this.selectedFiles[key]) {
                                const index = this.selectedFiles[key].indexOf(value.file);
                                if (index > -1) {
                                    this.selectedFiles[key].splice(index, 1);
                                }
                            }

                            const index2 = this.selectedTreeItems.indexOf(key+'|'+i);
                            if (index2 > -1) {
                                this.selectedTreeItems.splice(index2, 1);
                            }
                        }
                    }
                    const index3 = this.preCheckedFiles.indexOf(key);
                    if (index3 > -1) {
                        this.preCheckedFiles.splice(index3, 1);
                    }
                }

                this.selectedTreeItemsOld = _.cloneDeep(this.selectedTreeItems)
                this.selectedFilesOld = _.cloneDeep(this.selectedFiles)
                this.preCheckedFilesOld = _.cloneDeep(this.preCheckedFiles)
            } else {
                if (this.isSelectFileAllTreeItem) {
                    this.selectedTreeItems = [];
                    this.selectedFiles = {
                        '2-D Креслення': [],
                        'Інструкція': [],
                        'Сертифікат': [],
                    };

                    // expand all
                    for (const [index, value] of Object.entries(this.selectedProductFiles)) {
                        if (this.isSelectFileAllTreeItem) {
                            if (!this.selectedTreeItems.includes(index)) {
                                this.selectedTreeItems.push(index)
                            }
                        } else {
                            const mainKey = this.selectedTreeItems.indexOf(index);
                            if (mainKey > -1) {
                                this.selectedTreeItems.splice(mainKey, 1);
                            }
                        }

                        this.selectedFiles[index] = []


                        for (const [childKey, item] of Object.entries(value)) {
                            if (this.isSelectFileAllTreeItem) {
                                if (!this.selectedFiles[index].includes(item.file)) {
                                    this.selectedFiles[index].push(item.file)
                                }

                                if (!this.selectedTreeItems.includes(index+'|'+childKey)) {
                                    this.selectedTreeItems.push(index+'|'+childKey)
                                }
                            } else {
                                const index2 = this.selectedTreeItems.indexOf(index+'|'+childKey);
                                if (index2 > -1) {
                                    this.selectedTreeItems.splice(index2, 1);
                                }
                            }
                        }
                    }
                } else {
                    this.selectedTreeItems = _.cloneDeep(this.selectedTreeItemsOld)
                    this.selectedFiles = _.cloneDeep(this.selectedFilesOld)
                    this.preCheckedFiles = _.cloneDeep(this.preCheckedFilesOld)
                }
            }

            this.reculcSelectedFiles()
        },
        selectFileTreeItem (parent, key) {
            if (!this.selectedTreeItems.includes(parent+'|'+key)) {
                this.selectedTreeItems.push(parent+'|'+key)

                let file = this.selectedProductFiles[parent][key];

                if (!this.selectedFiles[parent]) {
                    this.selectedFiles[parent] = []
                }
                this.selectedFiles[parent].push(file.file)
            } else {
                const index = this.selectedTreeItems.indexOf(parent+'|'+key);
                if (index > -1) {
                    this.selectedTreeItems.splice(index, 1);
                }

                let file = this.selectedProductFiles[parent][key];
                if (this.selectedFiles[parent]) {
                    const index2 = this.selectedFiles[parent].indexOf(file.file);
                    if (index2 > -1) {
                        this.selectedFiles[parent].splice(index2, 1);
                    }
                }
            }

            let total = 0
            for (const [index, value] of Object.entries(this.selectedProductFiles[parent])) {
                total += 1
            }
            let currentTotal = 0
            if (this.selectedFiles[parent]) {
                for (const [index, value] of Object.entries(this.selectedFiles[parent])) {
                    currentTotal += 1
                }
            }

            if (currentTotal < total || currentTotal == total) {
                if (!this.selectedTreeItems.includes(parent)) {
                    this.selectedTreeItems.push(parent)
                }
            }

            if (currentTotal <= 0) {
                if (this.selectedTreeItems.includes(parent)) {
                    const index2 = this.selectedTreeItems.indexOf(parent);
                    if (index2 > -1) {
                        this.selectedTreeItems.splice(index2, 1);
                    }
                }
            }

            if (currentTotal > 0 && currentTotal < total) {
                if (!this.preCheckedFiles.includes(parent)) {
                    this.preCheckedFiles.push(parent)
                }
            } else {
                const index2 = this.preCheckedFiles.indexOf(parent);
                if (index2 > -1) {
                    this.preCheckedFiles.splice(index2, 1);
                }
            }

            this.selectedTreeItemsOld = _.cloneDeep(this.selectedTreeItems)
            this.selectedFilesOld = _.cloneDeep(this.selectedFiles)
            this.preCheckedFilesOld = _.cloneDeep(this.preCheckedFiles)

            console.log(this.selectedFilesOld)

            this.reculcSelectedFiles()
        },
        reculcSelectedFiles() {
            let countTotal = 0;
            let countSelected = 0;
            let selectedFiles = [];

            let totalSize = 0
            for (const [index, value] of Object.entries(this.selectedFiles)) {
                for (const [i, files] of Object.entries(value)) {
                    selectedFiles.push(files)
                    countSelected += 1
                }
            }

            for (const [index, value] of Object.entries(this.selectedProductFiles)) {
                for (const [i, files] of Object.entries(value)) {
                    if (selectedFiles.includes(files.file)) {
                        totalSize += files.size
                    }
                    countTotal += 1
                }
            }

            if (countTotal !== countSelected) {
                this.isSelectFileAllTreeItem = false
            } else {
                this.isSelectFileAllTreeItem = true
                this.preCheckedFiles = []
            }

            this.totalFilesSize = totalSize
        },
        dropKlemaFilters(key) {
            if (this.dopKlemaFilters.includes(key)) {
                let index = this.dopKlemaFilters.indexOf(key);
                if (index !== -1) {
                    this.dopKlemaFilters.splice(index, 1);
                }
            } else {
                this.dopKlemaFilters.push(key)
            }
        },
        selectFilterKlemy(key, option) {
            if (option) {
                if (!this.selected_klemy_filters[key]) {
                    this.selected_klemy_filters[key] = [];
                }

                if (this.selected_klemy_filters[key].includes(option)) {
                    let index = this.selected_klemy_filters[key].indexOf(option);
                    if (index !== -1) {
                        this.selected_klemy_filters[key].splice(index, 1);
                    }
                    
                    if (this.selected_klemy_filters_count > 1) {
                        this.selected_klemy_filters_count--;
                    }
                } else {
                    this.selected_klemy_filters[key].push(option)
                    this.selected_klemy_filters_count++;
                }
            }
            this.getTreeByType()
            this.$forceUpdate();
        },
        clearCustomKlemaFilter(title) {
            this.selected_klemy_filters_count = this.selected_klemy_filters_count - this.selected_klemy_filters[title].length
            this.selected_klemy_filters[title] = [];

            this.selected_klemy_filters_checkbox = this.selected_klemy_filters_checkbox.filter(e => !e.includes(title))

            this.getTreeByType()
            this.$forceUpdate();
        },
        clearCustomFilter(title) {
            const values = title.split('|')
            if (this.selected_klemy_filters[values[0]].includes(values[1])) {
                let index = this.selected_klemy_filters[values[0]].indexOf(values[1]);
                if (index !== -1) {
                    this.selected_klemy_filters[values[0]].splice(index, 1);
                }
                
                if (this.selected_klemy_filters_count > 1) {
                    this.selected_klemy_filters_count--;
                }
            }

            this.selected_klemy_filters_checkbox = this.selected_klemy_filters_checkbox.filter(e => !e.includes(title))

            this.getTreeByType()
            this.$forceUpdate();
        },
        getFilterTitle(title) {
            const values = title.split('|')
            return values[0] + ': ' + values[1]
        },
        expandFileTree (key) {
            if (!this.expandedTreeItems.includes(key)) {
                this.expandedTreeItems.push(key)
            } else {
                const index = this.expandedTreeItems.indexOf(key);
                if (index > -1) { // only splice array when item is found
                    this.expandedTreeItems.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
        },
        filesCount() {
            let count = 0;
            for (const [index, value] of Object.entries(this.selectedFiles)) {
                for (const [i, files] of Object.entries(value)) {
                    count += 1
                }
            }
            return count;
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },
        handleKeydown (e) {
            if (this.opensSliderModal) {
                switch (e.keyCode) {
                    case 37:
                        this.selectedMediaIndex > 0 ? this.selectedMediaIndex-- : this.selectedMediaIndex
                        break;
                    case 39: 
                        this.modalNextMedia();
                        break;
                    case 27: 
                        this.opensSliderModal = false;
                        this.overlay = false;
                        break;
                }
            }
        },
        clearSearch() {
            this.searchval = null;
            this.showClearInput = false;
            this.features_filter = [];
            this.sub_groups_filter = [];
            this.sub_group_filter = null;
        },

        opensSliderModalAction() {
            this.opensSliderModal = !this.opensSliderModal;
            this.overlay = true;
            this.$forceUpdate();
        },

        number_format(number, decimals, dec_point, thousands_sep) {
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },

        doRecalcCurr(curr) {
            this.selectedCurr = curr

            this.recalculation=true

            this.getTreeByType()
            if (this.selectedProductId) {
                this.getProduct(this.selectedProductId)
            }
        },

        modalNextMedia() {
            if (this.selectedMediaIndex <= this.selectedProductMediaFiles.length - 2) {
                this.selectedMediaIndex++
            } else {
                this.selectedMediaIndex = 0
            }
            this.$forceUpdate();
        },

        getSearchProducts() {
            this.isShowCatalog = false
            this.showGroups = []
            this.searchResult = false
            this.overlay = false
            this.loadingData = true

            axios.post(this.route('api.vector.get-searched-products'), {value: this.searchval})
            .then((result) => {
                this.searchedProducts = result.data.products;
                this.selectedItemTitle = result.data.value;

                this.is_toggle_1 = true;
                this.is_toggle_2 = false;
                this.is_toggle_3 = false;

                const el = document.getElementById('form_section');

                if (el) {
                    el.scrollIntoView();

                    window.scroll({ top: el.offsetTop - 25, left: 0, behavior: 'smooth' });
                }
                this.loadingData = false
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })
        },
        
        async getTreeByType(type, value, title) {
            // get url get params
            let uri = window.location.search.substring(1); 
            let params = new URLSearchParams(uri);

            this.isShowCatalog = false
            this.showGroups = []
            this.searchResult = false
            this.overlay = false
            this.loadingData = true

            this.searchedProducts = null
            this.totalTreeProducts = 0
            this.mobileCatalog = false

            if (type) {
                this.selectedType = type;
                this.selectedCode = value;
                this.selectedTitle = title;
                this.selectedItemTitle = title;

                this.insertParam('selected_type', this.selectedType)
                this.insertParam('selected_code', this.selectedCode)
                this.insertParam('selected_title', this.selectedTitle)
                this.insertParam('selected_item_title', this.selectedItemTitle)
            }

            let eurCurr = 0
            if (this.selectedCurr == 'грн') {
                eurCurr = this.currencies[0].value
            }

            axios.post(this.route('api.vector.catalog-tree-by-type'), {
                type: this.selectedType,
                value: this.selectedCode,
                curr: eurCurr,
                pdw: this.pdw,
                selected_klemy_filters: this.selected_klemy_filters,
            })
            .then((result) => {
                this.catalog = result.data;
                if (!this.selected_klemy_filters_checkbox.length && !this.recalculation) {
                    this.features_filter = result.data.features_filter
                }
                this.sub_groups_filter = result.data.sub_groups_filter

                let ids = []

                if (type && this.selectedType !== 'brand' && this.selectedType !== 'searched_products') {
                    for (const node of result.data.tree) {
                        ids.push(node.code)
                        for (const child of node.childs) {
                            if (node.childs.length == 1) {
                                ids.push(child.code)
                            }
                            for (const subChild of child.childs) {
                                if (child.childs.length == 1) {
                                    ids.push(subChild.code)
                                }
                            }
                        }
                    }

                    this.expandedCategories = ids
                    this.selectedItemTitle = title
                }

                if (this.selectedType == 'brand' || this.selectedType == 'searched_products' || this.selectedType == 'single_product') {
                    this.searchedProducts = result.data.products;
                    this.totalTreeProducts = result.data.products.length
                } else {
                    this.totalTreeProducts = result.data.total
                }
                this.insertParam('selected_products', this.totalTreeProducts)

                this.is_toggle_1 = true

                this.loadingData = false

            }).finally(() => {
                if (params.has("product")) {
                    const table = document.getElementById('toggle_content_table');
                    const el = document.getElementById(params.get("product"));

                    if (el) {
                        this.scrollTop()

                        table.scroll({ top: (el.offsetTop - 430), left: 0, behavior: 'smooth' });
                    }
                }

                if (!Object.keys(this.features_filter).length) {

                    this.loadingData = true
                    let eurCurr = 0
                    if (this.selectedCurr == 'грн') {
                        eurCurr = this.currencies[0].value
                    }
                    this.toggleCurrencies = false;

                    axios.post(this.route('api.vector.catalog-tree'), {curr: eurCurr, pdw: this.pdw})
                    .then((result) => {
                        this.catalog = result.data;
                        this.submenuTree = _.cloneDeep( this.catalog );
                        this.searchTree = _.cloneDeep( this.catalog );

                        this.submenuTree.tree.forEach((v, index) => {
                            v.childs = this.chunk(v.childs)
                        });
                        this.submenuTree.brands.forEach((v, index) => {
                            v.groups = this.chunk(v.groups)
                        });

                        this.loadingData = false
                    }).catch((error) => {
                        console.log(error);
                        window.scroll(0, 0);
                        this.loadingData = false
                    })
                }
                if (Object.keys(this.features_filter).length) {

                    this.loadingData = true
                    let eurCurr = 0
                    if (this.selectedCurr == 'грн') {
                        eurCurr = this.currencies[0].value
                    }
                    this.toggleCurrencies = false;

                    axios.post(this.route('api.vector.catalog-tree'), {curr: eurCurr, pdw: this.pdw})
                    .then((result) => {
                        this.submenuTree = _.cloneDeep( result.data );
                        this.searchTree = _.cloneDeep( result.data );

                        this.submenuTree.tree.forEach((v, index) => {
                            v.childs = this.chunk(v.childs)
                        });
                        this.submenuTree.brands.forEach((v, index) => {
                            v.groups = this.chunk(v.groups)
                        });

                        this.loadingData = false
                    }).catch((error) => {
                        console.log(error);
                        window.scroll(0, 0);
                        this.loadingData = false
                    })
                }

                this.recalculation = false
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })

            await nextTick()

            this.scrollTop()

            // if (type) {
            //     const el = document.getElementById('tree_toggle');

            //     if (el) {
            //         el.scrollIntoView();

            //         window.scroll({ top: (el.offsetTop - 80), left: 0, behavior: 'smooth' });
            //     }
            // }
        },

        scrollTop() {
            const el = document.getElementById('form_section');
            if (el) {
                window.scrollTo({
                    top: el.offsetTop - 25,
                    behavior: "smooth"
                });
            }
        },

        getByBrand(id, title) {
            this.isShowCatalog = false
            this.showGroups = []
            this.searchResult = false
            this.overlay = false
            this.mobileCatalog = false
            // this.searchval = id
            this.loadingData = true

            let eurCurr = 0
            if (this.selectedCurr == 'грн') {
                eurCurr = this.currencies[0].value
            }

            axios.post(this.route('api.vector.get-searched-brand-products'), {
                value: id,
                curr: eurCurr,
                pdw: this.pdw
            })
            .then((result) => {
                this.searchedProducts = result.data.products;
                this.selectedItemTitle = 'Бренд: ' + title;

                this.totalTreeProducts = result.data.products.length

                this.is_toggle_1 = true;
                this.is_toggle_2 = false;
                this.is_toggle_3 = false;

                const el = document.getElementById('form_section');

                if (el) {
                    el.scrollIntoView();

                    window.scroll({ top: el.offsetTop - 25, left: 0, behavior: 'smooth' });
                }
                this.loadingData = false
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })
        },

        downloadPriceList() {
            this.isDownloadPriceList = true
            axios.post(this.route('api.vector.catalog-price-list'))
            .then((response) => {
                this.isDownloadPriceList = false
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                this.isDownloadPriceList = false
                alert(error);
                window.scroll(0, 0);
            })
        },

        sortNodes(nodes, selected, key, direction) {
            for (const node of nodes) {
                if (node.code && selected.includes(node.code)) {
                    if (node.childs && node.childs[0].description) {
                        if (direction == 'desc') {
                            node.childs.sort(function(a, b){
                                if(a[key] > b[key]) { return -1; }
                                if(a[key] < b[key]) { return 1; }
                                return 0;
                            })
                        } else {
                            node.childs.sort(function(a, b){
                                if(a[key] < b[key]) { return -1; }
                                if(a[key] > b[key]) { return 1; }
                                return 0;
                            })
                        }
                    }

                    if (node.childs && node.childs.length) {
                        this.sortNodes(node.childs, selected, key, direction);
                    }
                }
            }
        },

        recursiveChangeCurr(nodes, curr, type) {
            for (const node of nodes) {
                if (node.childs && node.childs.length && node.childs[0].name) {
                    for (const product of node.childs) {
                        if (type == '*') {
                            product.price = (parseFloat(product.price) * curr).toFixed(2);
                        } else {
                            product.price = (parseFloat(product.price) / curr).toFixed(2);
                        }
                    }
                }

                if (node.childs && node.childs.length) {
                    this.recursiveChangeCurr(node.childs, curr, type);
                }
            }
        },

        async toggle(n) {
            switch (n) {
                case 1:
                    this.is_toggle_1 = !this.is_toggle_1
                    // this.is_toggle_2 = false
                    // this.is_toggle_3 = false
                    break
                case 2:
                    // this.is_toggle_1 = false
                    this.is_toggle_2 = !this.is_toggle_2
                    this.is_toggle_3 = false
                    break
                case 3:
                    // this.is_toggle_1 = false
                    this.is_toggle_2 = false
                    this.is_toggle_3 = !this.is_toggle_3
                    break
            }

            await nextTick()

            const el = document.getElementById('form_section');

            if (el) {
                // el.scrollIntoView();

                window.scroll({ top: el.offsetTop - 25, left: 0, behavior: 'smooth' });
            }


            this.$forceUpdate();
        },

        getCurr() {
            axios.get(this.route('api.vector.catalog.currencies'))
            .then((result) => {
                this.currencies = result.data.result;
                this.getTree();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        getProduct(id) {
            this.insertParam('product', id.id ? id.id : id)

            const el = document.getElementById('modalSubItems');

            if (el) {
                el.scroll(0, 0);
            }
            this.selectedMediaIndex = 0
            let eurCurr = 0
            if (this.selectedCurr == 'грн') {
                eurCurr = this.currencies[0].value
            }
            
            if (id) {
                this.selectedProductId = id.id ? id.id : id
            }
            axios.post(this.route('api.vector.catalog-product'), {
                id: this.selectedProductId,
                curr: eurCurr,
                pdw: this.pdw
            })
            .then((result) => {
                this.selectedProduct = result.data.product;
                this.selectedProductMediaFiles = result.data.mediaFiles;
                this.selectedProductDescription = result.data.description;
                this.selectedProductFeatures = result.data.features;
                this.selectedProductAccesories = result.data.accesories;
                this.selectedProductFiles = result.data.files;
                this.totalFilesSize = result.data.files_size;
                // this.features_filter = result.data.features_filter;

                this.expandedTreeItems = []
                this.selectedFiles = {
                    '2-D Креслення': [],
                    'Інструкція': [],
                    'Сертифікат': [],
                }
                this.selectedTreeItems = []

                // expand all
                for (const [index, value] of Object.entries(this.selectedProductFiles)) {
                    if (this.isSelectFileAllTreeItem) {
                        if (!this.selectedTreeItems.includes(index)) {
                            this.selectedTreeItems.push(index)
                        }
                    } else {
                        const mainKey = this.selectedTreeItems.indexOf(index);
                        if (mainKey > -1) {
                            this.selectedTreeItems.splice(mainKey, 1);
                        }
                    }

                    // this.selectedFiles[index] = []


                    for (const [childKey, item] of Object.entries(value)) {
                        if (this.isSelectFileAllTreeItem) {

                            if (!this.selectedFiles[index]) {
                                this.selectedFiles[index] = []
                            }
                            if (!this.selectedFiles[index].includes(item.file)) {
                                this.selectedFiles[index].push(item.file)
                            }

                            if (!this.selectedTreeItems.includes(index+'|'+childKey)) {
                                this.selectedTreeItems.push(index+'|'+childKey)
                            }
                        } else {
                            const index2 = this.selectedTreeItems.indexOf(index+'|'+childKey);
                            if (index2 > -1) {
                                this.selectedTreeItems.splice(index2, 1);
                            }
                        }
                    }

                    this.preCheckedFiles = []
                    this.isSelectFileAllTreeItem = true
                    this.selectFileAllTreeItem()
                    
                }
            }).finally(() => {
                this.scrollTop();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        downloadFiles() {
            let files = []
            this.fileownloading = true
            for (const [index, value] of Object.entries(this.selectedFiles)) {
                files.push(value)
            }

            if (files.length) {
                axios.post(this.route('api.vector.download-files'), {
                    files: files,
                }, {
                    responseType: 'blob'
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", 'Документи_' + this.selectedProduct.article + '_' + this.selectedProduct.name + '.zip');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.fileownloading = false
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                })
            } else {
                this.fileownloading = false
            }
        },

        async getTree() {
            // get url get params
            let uri = window.location.search.substring(1); 
            let params = new URLSearchParams(uri);

            if (params.has("selected_type")) {
                this.getTreeByType(params.get("selected_type"), params.get("selected_code"), params.get("selected_title"))
            } else {
                this.loadingData = true
                let eurCurr = 0
                if (this.selectedCurr == 'грн') {
                    eurCurr = this.currencies[0].value
                }
                this.toggleCurrencies = false;

                axios.post(this.route('api.vector.catalog-tree'), {curr: eurCurr, pdw: this.pdw})
                .then((result) => {
                    this.catalog = result.data;
                    this.submenuTree = _.cloneDeep( this.catalog );
                    this.searchTree = _.cloneDeep( this.catalog );

                    this.submenuTree.tree.forEach((v, index) => {
                        v.childs = this.chunk(v.childs)
                    });
                    this.submenuTree.brands.forEach((v, index) => {
                        v.groups = this.chunk(v.groups)
                    });

                    this.loadingData = false
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                    this.loadingData = false
                }).finally(() => {
                    if (params.has("product")) {
                        const table = document.getElementById('toggle_content_table');
                        const el = document.getElementById(params.get("product"));

                        if (el) {
                            this.scrollTop()

                            table.scroll({ top: (el.offsetTop - 430), left: 0, behavior: 'smooth' });
                        }
                    }
                })
            }

            if (params.has("selected_categories")) {
                this.expandedCategories = params.get("selected_categories").split(',').map(el => {
                    let n = Number(el);
                        return n === 0 ? n : n || el;
                    });
            }

            if (params.has("product")) {
                this.getProduct(params.get("product"))
                this.selectedProductId = parseInt(params.get("product"))
            }

            await nextTick()
        },

        expandCategory(data) {
            if (this.expandedCategories.includes(data.id))
                this.expandedCategories = this.expandedCategories.filter((id) => id !== data.id)
            else {
                this.expandedCategories.push(data.id)
            }

            this.insertParam('selected_categories', this.expandedCategories)

            this.scrollTop()
        },

        itemExpandCategory(data) {
            if (this.itemExpandedCategories.includes(data.id))
                this.itemExpandedCategories = this.itemExpandedCategories.filter((id) => id !== data.id)
            else
                this.itemExpandedCategories.push(data.id)
        },

        async expandCategoryCustom(id, title, ids) {
            this.selectedItems = ids
            this.selectedItemTitle = title

            this.expandedCategories = ids
            this.isShowCatalog = false
            this.showGroups = []
            this.searchResult = false
            this.overlay = false
            this.mobileCatalog = false
            this.searchedProducts = null

            this.is_toggle_1 = true;
            this.is_toggle_2 = false;
            this.is_toggle_3 = false;

            await nextTick()

            const el = document.getElementById(id);

            if (el) {
                el.scrollIntoView();

                window.scroll({ top: (el.offsetTop - 80), left: 0, behavior: 'smooth' });
            }
        },

        closeSearch() {
            this.selectedItems = null
            this.selectedItemTitle = null
            this.searchedProducts = null
            this.expandedCategories = []
            this.selectedCategories = []
            this.features_filter = []
            this.sub_groups_filter = []

            this.selectedType = null;
            this.selectedCode = null;
            this.selectedTitle = null;

            this.deleteParam(['selected_type', 'selected_code', 'selected_title', 'selected_item_title', 'selected_products', 'selected_categories', 'product']);

            this.selected_klemy_filters = {}
            this.selected_klemy_filters_checkbox = []

            this.getTree()
        },

        search() {
            if (this.searchval) {
                this.showClearInput = true;
            } else {
                this.showClearInput = false;
            }
            if (this.searchval && this.searchval.length > 2) {
                axios.post(this.route('api.vector.catalog-tree-search'), {value: this.searchval})
                    .then((result) => {
                        this.isShowAllGroupsRes = false;
                        this.isShowAllSubGroupsRes = false;

                        this.searchProducts = result.data.products;
                        this.searchGroups = result.data.groups;
                        this.searchCats = result.data.subgroups;
                        this.searchTotal = result.data.total;

                        this.overlay = true;
                        this.searchResult = true;
                    }).catch((error) => {
                        console.log(error);
                        this.searchResult = true;
                        window.scroll(0, 0);
                    })
            }
        },

        sortBy(key) {
            if (this.catalog.tree && !this.searchedProducts) {
                this.sortByName = key
                if (this.sortByDirection == 'asc') {
                    this.sortByDirection = 'desc'
                } else {
                    this.sortByDirection = 'asc'
                }
            }
            if (this.searchedProducts) {
                if (this.sortByDirection == 'asc') {
                    this.sortByDirection = 'desc'
                } else {
                    this.sortByDirection = 'asc'
                }

                if (this.sortByDirection == 'desc') {
                    this.searchedProducts.sort(function(a, b){
                        if(a[key] > b[key]) { return -1; }
                        if(a[key] < b[key]) { return 1; }
                        return 0;
                    })
                } else {
                    this.searchedProducts.sort(function(a, b){
                        if(a[key] < b[key]) { return -1; }
                        if(a[key] > b[key]) { return 1; }
                        return 0;
                    })
                }

            }
        },

        expandGroup(id) {
            this.showGroups.push(id)
        },

        chunk(arr) {
            const len = Math.ceil(arr.length / 3)
            const chunks = []
            let i = 0
            const n = arr.length

            if (n) {
                while (i < n) {
                    chunks.push(arr.slice(i, i += len))
                }
            }

            return chunks
        },

        selectCurrentChilds(title, code, childs, type) {
            this.selectedMobileMenuTitle = title
            this.selectedMobileMenuType = type
            this.selectedMobileMenuChilds = childs
            this.selectedMobileMenuCode = code
        },

        expandMobileMenuSubgroup(code) {
            if (this.selectedMobileMenuExpandedSubgroups.includes(code)) {
                let index = this.selectedMobileMenuExpandedSubgroups.findIndex(p => p == code);
                this.selectedMobileMenuExpandedSubgroups.splice(index, 1)
            } else {
                this.selectedMobileMenuExpandedSubgroups.push(code)
            }
        },
    }
};
</script>

<style scoped>
.ja-center {
    display: flex;
    align-items: center;
    justify-content: center;
}
#form_section {
    max-width: 2560px;
    margin: 0 auto;
    padding-top: 0px;
}
.container {
    padding: 80px 25px 0 20px;
}

.content_header {
    display: flex;
    margin-top: 22px;
    margin-bottom: 26px;
}

.mobile_cats_btn {
    width: 100%;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    display: none;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .content_header {
        flex-direction: column;
    }
}

.content_header_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
    min-width: 330px;
    margin: 0px 24px 0px 0px;
}
.info_btn {
    width: 200px;
    height: 48px;
    padding: 12px 10px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
}
.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}
.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}
#close_modal {
    cursor: pointer;
}
.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.product_media_modal .modal_content {
    max-height: 585px;
    margin-top: 0px;
}
.product_media_modal {
    padding: 0px;
    border-radius: 0px;
}
.product_media_modal #close_modal{
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
}

.download_modal.modal {
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    padding: 0;
}
.download_modal .modal_header {
    background: #C8E4FF;
    border-radius: 4px 4px 0px 0px;
    padding: 12px 20px;
}
.download_modal .modal_content {
    margin: 26px 26px 26px 26px;
    border: 1px solid #C8E4FF;
    padding: 20px;
}

.download_modal .modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
}

.row_file {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.modal_file_name {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    white-space: nowrap;
    padding-right: 20px;
}
.modal_file_loading {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    white-space: nowrap;
}
.modal_file_link {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #356EEF;
    display: flex;
    align-items: center;
    gap: 10px;
}

.underline {
    width: 100%;
    height: 1px;
    border: 0.5px solid #C8E4FF;
}

.toggle_row {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.toggle {
    width: 100%;
}
.toggle .title {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #919299;
}
.toggle_header {
    display: flex;
    align-items: center;
    height: 40px;
    justify-content: space-between;
    padding: 0 25px 0 25px;
    background: #C8E4FF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    cursor: pointer;
}
.toggle_header.active {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.files_modal .form_label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;
    color: #212529;
    gap: 11px;
    margin-top: 12px;
}
.cater.active {
    transform: rotate(180deg);
}
.toggle_content {
    height: 303px;
    overflow: auto;
    padding: 25px;
    border: 1px solid #C8E4FF;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.toggle_content.nested-content {
    height: 28vh;
}

.toggle_content.active {
    height: 26vh;
}

.toggle_content.active.filter_mode {
    height: 20vh;
}

.description_content {
    height: 30vh;
}

.catalog_header {
    width: 100%;
}

.catalog-sub-menu_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
}

.catalog-sub-menu {
    position: relative;
    min-width: 330px;
    height: 48px;
    z-index: 5;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    justify-content: space-between;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
    cursor: pointer;
}
.sub_menu_title {
    display: flex;
    align-items: center;
}
.sub_menu_title span {
    margin-left: 8px;
}
.sub_menu_title.mobile {
    display: none;
    color: #356EEF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 48px;
    padding: 10px 16px;
    border-radius: 4px;
    border: 1px solid #C8E4FF;
    background: #FFF;
}

.search_input_container {
    position: relative;
    z-index: 3;
    width: 100%;
}

.search_input_container svg {
    position: absolute;
    top: 15px;
    right: 15px;
}

.catalog_search_input {
    padding: 6px 16px;
    padding-right: 40px;
    min-width: 461px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
}

.catalog_search_input:focus {
    outline: none;
}

.currencies_btn, .download_btn {
    display: flex;
    align-items: center;
    gap: 9px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    height: 48px;
    cursor: pointer;
    padding: 0px 10px;
}

span.curr_name {
    width: 26px;
}

span.pdv_name:first-child {
    width: 38px;
}
span.pdv_name:last-child {
    width: 52px;
}

.currencies_btn.active {
    background: #E3F2FF;
    border-radius: 4px;
}

.curr_section {
    position: relative;
}

.curr_container {
    position: absolute;
    top: 49px;
    width: 182px;
    height: 286px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    z-index: 3;
}

.curr_container .curr_item {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    margin-bottom: 10px;
}

.curr_container .text_titled {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    margin-top: 15px;
}

.curr_container .curr_selection {
    display: flex;
    align-items: center;
    gap: 10px;
}

.curr_container .curr_selection span {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    cursor: pointer;
}

.curr_container .curr_selection span.active {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #356EEF;
}

.curr_container .vertical_line {
    width: 1px;
    height: 22px;
    border: 1px solid #CED4DA;
}

.menu-container {
    min-width: 330px;
    /* height: 780px; */
    height: 75vh;
    display: flex;
    position: absolute;
    top: 46px;
    left: -1px;
    box-sizing: border-box;
    padding: 9px 0px 0px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 8px;
    margin-top: 16px;
}

.menu {
    overflow-y: auto;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.menu::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

.menu li {
    padding: 0 18px;
}

.group_item {
    width: 280px;
    padding: 10px;
}
ul.menu {
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex!important;
  flex-direction: column;
}
ul.menu .groups_items {
  width: 100%;
  padding: 0;
  margin: 0;
  display: none;
  flex-direction: column;
}
ul.menu li {
    list-style: none;
}
ul.menu > li {
    height: auto;
    width: 100%;
}
.menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
ul.menu li a,
ul.menu .groups_items a {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 1px;
}
ul.menu>li:hover {
    background: #EFF8FF;
}
ul.menu li:hover .groups_items,
ul.menu .groups_items .group_item:hover .groups_items {
    display: flex;
    flex-direction: row;
}

ul.menu .groups_items {
    width: 922px;
    max-width: 922px;
    /* height: 873px; */
    height: 82vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    margin: 0 0px 0 310px;
    top: -64px;
    z-index: 2;
    box-sizing: border-box;
    padding: 30px 0px 30px 10px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 0px 0px 0px 4px;
    grid-template-columns: 1fr 1fr 1fr;
}

.nav {
  display: flex;
  flex-direction: row;
}
.nav > .nav-item:hover > .menu-container,
.nav > .nav-item:hover > .menu-container > .menu {
  display: flex;
}

.sub_group {
    font-style: normal;
    font-weight: 400;
    font-size: 14px!important;
    line-height: 21px!important;
    color: #000000;
    display: flex;
    flex-direction: column;
}

.sub_group:hover {
    color: #356EEF!important;
}

.menu-item-arrow {
    transform: rotate(270deg);
    width: 20px;
}

.menu-item-title {
    padding: 10px 0px;
}

.group_title {
    display: block;
}

.brands {
    border-top: 1px solid #C8E4FF;
    border-bottom: 1px solid #C8E4FF;
}

.brands-title {
    color: #356EEF;
}

.search_input_block {
    position: relative;
}

.search_results {
    position: absolute;
    top: 48px;
    height: 500px;
    overflow: auto;
    background: #FFFFFF;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #C8E4FF;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.search_results .cat_title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 6px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .cat_title:hover {
    background: rgba(200, 228, 255, 0.5);
}

.search_results .main_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
    padding: 12px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .show_all_link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
    padding: 0px 16px;
}

.search_results .products {
    width: 65%;
    border-right: 1px solid #E3F2FF;
}

.search_results .categories {
    width: 35%;
}

.drop_more {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #000000;
}

.toggle_content {
    padding: 0px!important;
}

.zindex1 {
    z-index: 1!important;
}

.pi-chevron-right:before {
    color: #356EEF!important;
}

.item_table {
    width: 100%;
    text-align: left;
    border-left: 1px solid #C8E4FF;
    border-right: 1px solid #C8E4FF;
}

.item_table.self_table {
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #C8E4FF;
}

.item_table tr {
    display: flex;
}

.item_table th {
    padding: 8px 0px 8px 22px;
}

.d-flex {
    display: flex;
    align-items: center;
    gap: 11px;
}

.sortable_ico {
    cursor: pointer;
}

.sortable_ico:hover path {
    fill: #356EEF;
}

.search_result {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
}
.close_results {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 13px;
    cursor: pointer;
    min-width: 170px;
}
.results_badge {
    background: #EFF8FF;
    border: 1px solid #FFFFFF;
    border-radius: 30px;
    padding: 4px 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    /* max-width: 600px; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
}

.results_badge svg {
    cursor: pointer;
}

.item_table {
    width: 100%;
    text-align: left;
}

.item_table tr {
    display: flex;
}

.item_table th {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 13px;
    color: #000000;
    word-break: break-word;
}

.d-flex {
    display: flex;
    align-items: center;
    gap: 11px;
}

.product-item {
    cursor: pointer;
}

.tree_item_container {
    border-bottom: 1px solid #C8E4FF;
}

.tree_item_container:hover {
    background: #C8E4FF;
}

.toggle_content .tabs {
    height: 38px;
    border-bottom: 1px solid #C8E4FF;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0px 20px;
    gap: 34px;
}

.toggle_content .tab_item {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    padding: 4px 10px;
    cursor: pointer;
}

.toggle_content .tab_item.active {
    background: #E3F2FF;
    border-radius: 4px;
}

.product_info_container {
    display: flex;
    padding-left: 16px;
}

.product_info_container .block_main_info .product_info_text:last-child {
    margin-top: 6px;
}

.block_main_info {
    display: flex;
    flex-direction: column;
    width: 280px;
}

.block_images {
    display: flex;
    gap: 20px;
    height: 145px;
    padding-top: 6px;
    justify-content: center;
}

.sub_images {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 200px;
    overflow: auto;
}

.product_media_modal_sub_images {
    width: 100%;
    display: flex;
    gap: 17px;
    overflow: auto;
    padding: 5px 10px 0px 10px;
    margin-bottom: 10px;
}

.product_img {
    width: 47px;
    height: auto;
    cursor: pointer;
}

.product_media_modal_img {
    width: 48px;
    height: 48px;
    cursor: pointer;
}

.main_img_container {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 180px;
}
.main_img_container svg {
    position: absolute;
    bottom: 8px;
    right: 8px;
    cursor: pointer;
}

.product_info_text {
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #212529;
    margin-top: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 95%;
    height: 1.3em;
    white-space: nowrap;
}

.block_info {
    width: 100%;
}

.info_list {
    border-left: 1px solid #C8E4FF;
    height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
}

.info_list_content {
    display: flex;
    flex-direction: column;
    padding: 29px 20px;
    gap: 14px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
}

.info_list_content.table_container {
    padding: 0px;
    gap: 0px;
}

.info_list_content .info_list_item {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    position: relative;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-align-items: flex-start;
}

.docs_row {
    display: flex;
    gap: 20px;
    padding-left: 20px;
}

.info_list_item p {
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    background-color: #fff;
}

.info_list_item_value {
    text-align: end;
    min-width: 60px;
}

.info_list_item_title {
    text-wrap: nowrap;
}

.info_list_item_title::before {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    top: 16px;
    height: 1px;
    background-color: #C8E4FF;
    z-index: -1;
}

.download_all_btn {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #356EEF;
    align-items: center;
    gap: 11px;
    margin-right: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: flex-end;
}

.mobile_catalog {
    position: absolute;
    overflow: auto;
    top: 70px;
    height: 100%;
    background: #ffff;
    z-index: 5;
}

.mobile_catalog_container {
    padding-right: 20px;
    display: flex;
    flex-direction: column;
}

.mobile_catalog_container_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0px;
    border-bottom: 1px solid #C8E4FF;
}

.mobile_catalog_main_title {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
}

.mobile_catalog_title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    padding-bottom: 8px;
    border-bottom: 1px solid #C8E4FF;
    margin-top: 10px;
}

.mobile_catalog_sub_title {
    color: #356EEF;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    padding: 8px 0px;
    border-top: 1px solid #C8E4FF;
    border-bottom: 1px solid #C8E4FF;
}

.mobile_catalog_item {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 10px;
    margin-top: 10px;
    display: block;
}

.item_title_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.item_title_row.active {
    color: #356EEF;
}

.item_title_caret {
    transform: rotate(-90deg);
}

.item_title_caret_back {
    transform: rotate(90deg);
}

.item_title_caret_subchild {
    transform: rotate(0deg);
}

.item_title_caret_subchild.active{
    transform: rotate(180deg);
}

.mobile_catalog_item .child {
    padding-left: 20px;
}

.back_container {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    gap: 10px;
}

.right_section {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    min-width: 275px;
}

.product_main_img {
    width: auto;
    height: 131px;
}

.data-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #356EEF;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #356EEF transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 800px) {
    .item_table_mobile {
        display: none;
    }
    .item_table {
        min-width: 1234px;
    }
    .product_info_container {
        flex-direction: column;
        align-items: center;
        padding-right: 16px;
    }
    .block_info {
        width: 100%;
    }
    .catalog-sub-menu {
        display: none;
    }
    .catalog-sub-menu_container {
        flex-direction: column;
    }
    .catalog-sub-menu {
        display: none;
    }
    .search_input_container, .catalog_search_input {
        width: 100%;
        min-width: 100%;
    }
    .download_btn span, .currencies_btn span {
        display: none;
    }
    .catalog-sub-menu_container {
        align-items: baseline;
    }
    .search_results {
        flex-direction: column;
    }
    .right_section {
        justify-content: flex-start;
    }
    .search_results .categories {
        width: 100%;
    }
    .search_results .products {
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px solid #E3F2FF;
    }
    .content_header_title {
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 33.6px;
    }
    .info_btn {
        width: 100%;
        justify-content: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .filters {
        margin-bottom: 10px;
    }
    .currencies_btn, .download_btn {
        height: 30px;
    }
    .toggle_content .tabs {
        padding: 0px 1px 0px 10px;
        height: auto;
        justify-content: start;
    }
    .tabs_row {
        flex-direction: column;
        padding: 5px 0px;
    }
    .description_content {
        height: 100%;
    }
    .info_list {
        height: 100%;
        border-radius: 4px;
        border: 1px solid #C8E4FF;
        margin-top: 28px;
        margin-bottom: 19px;
    }
    .underline {
        display: none;
    }
    .info_list_content .info_list_item {
        justify-content: start;
        align-items: self-start;
        flex-direction: column;
        gap: 5px;
    }
    .info_list_item p:first-child {
        font-weight: 500;
        white-space: break-spaces;
    }
    .info_list_item p:last-child {
        white-space: break-spaces;
    }
    .row_file {
        flex-direction: column;
        align-items: start;
        gap: 16px;
    }
    .docs_row {
        padding: 0px;
    }
    .info_list_content {
        padding: 24px 20px;
        gap: 24px;
    }
    .toggle_content.active {
        height: 900px;
    }
    .search_result {
        height: auto;
        flex-direction: column;
        align-items: self-start;
        padding: 10px 5px;
        gap: 5px;
    }
    .results_badge {
        margin-left: 0px;
        white-space: break-spaces;
    }
    .toggle_content.nested-content {
        height: 900px;
    }
    .sub_menu_title.mobile {
        display: flex;
    }
}

@media (max-width: 450px) {
    .modal {
        width: 100%;
    }
    .mobile_cats_btn {
        display: flex;
    }
    .close_results {
        font-size: 10px;
        line-height: 16px;
        padding-left: 10px;
    }
}

@media (max-width: 420px) {
    .modal, .description_modal, .docs_modal {
       width: 385px;
    }
}

@media (max-width: 390px) {
    .modal, .description_modal, .docs_modal {
        width: 330px;
    }
}

.product-item.active {
    background-color: #C8E4FF;
}
.product_img.active {
    border: 1px solid #C8E4FF;
}
.product_media_modal_img.active {
    border: 1px solid #C8E4FF;
}
.product_video_iframe {
    pointer-events: none;
}

.product_media_modal_main_img {
    width: 100%;
    height: auto;
    max-height: 465px;
}
.product_media_modal_main_img_container {
    position: relative;
    min-height: 58vh;
    display: flex;
    align-items: center;
}
.product_media_modal_main_img_container .group_btns {
    display: flex;
    gap: 30px;
    position: absolute;
    bottom: 20px;
    right: 20px;
}
.files_modal {
    width: 315px;
    padding: 0px;
    border-radius: 4px 4px 0px 0px;
    height: 60vh;
}
.files_modal .modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
}
.files_modal .modal_header {
    padding: 12px 20px 12px 20px;
    background: #C8E4FF;
}
.files_modal .modal_content {
    padding: 0px 5px 12px 20px;
    max-height: 40vh;
    height: 40vh;
    overflow: scroll!important;
}
.modal_content_footer_subtitle {
    display: block;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #6C757D;
    margin-top: 4px;
}
.modal_content_footer {
    padding: 12px 20px 12px 20px;
    border-top: 1px solid #C8E4FF;
}
.modal_content_footer_btn {
    width: 130px;
    height: 30px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #FFFFFF;
    padding: 12px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
}
.toggle {
	 cursor: pointer;
	 display: inline-block;
}
 .toggle__switch {
    display: inline-block;
    background: #FFFFFF;
    border: 1.25px solid rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    width: 20px;
    height: 10px;
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
    margin-right: 8px;
}
 .toggle__switch:before, .toggle__switch:after {
	 content: '';
}
 .toggle__switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
    width: 8px;
    height: 8px;
    position: absolute;
    transition: left 0.25s;
}
 .toggle:hover .toggle__switch:before {
	 background: linear-gradient(to bottom, #fff 0%, #fff 100%);
	 box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
 .toggle__checkbox:checked + .toggle__switch {
	 background: #0D6EFD;
}
 .toggle__checkbox:checked + .toggle__switch:before {
	 left: 11px;
}
 .toggle__checkbox {
	 position: absolute;
	 visibility: hidden;
}
 .toggle__label {
	 margin-left: 5px;
	 position: relative;
	 top: 2px;
}

.form_radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}
input[type='checkbox'] {
    outline: 2px solid #356EEF;
    outline-style: auto;
}
input[type='checkbox']:checked {
    outline: 2px solid #356EEF;
    outline-style: auto;
}
input[type='checkbox']:not(:checked) {
    outline: 2px solid #356EEF;
    outline-style: auto;
}
.checkbox_tree {
}
.checkbox_tree_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.checkbox_tree_body {
    padding-left: 30px;
}
.checkbox_tree_items {
    width: 100%!important;
}

svg.expanded {
    transform: rotate(180deg);
}

.tabs_row {
    display: flex;
    padding: 5px 0px;
}
.tabs_row_item {
    display: flex;
    align-items: center;
}

#toggle_content_table.full_height {
    height: 58vh;
}

#toggle_content_table.full_height.filter_mode {
    height: 50vh;
}

.content_container_row {
    display: flex;
    gap: 24px;
}

.content.left {
    width: 100%;
}

.klema_item_dop_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.klema_item_dop_header.active {
    padding-bottom: 12px;
}
.klema_item_dop_header h5 {
    margin-bottom: 0px;
}
.klema_item_dop_header svg:hover {
    cursor: pointer;
}
.klema_item {
    margin-bottom: 8px;
    background: #FFF;
    padding: 12px;
    cursor: pointer;
    border-bottom: 1px solid #C8E4FF;
}
.options_container {
    /* height: 780px; */
    height: 77vh;
    overflow-x: auto;
    padding: 15px;
    margin-bottom: 25px;
    border-radius: 4px;
    border: 1px solid #C8E4FF;
    margin-top: 24px;
    max-width: 330px;
}
.filter_header_title {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 21.6px;
}
.klema_sub_filter_title {
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.badge_select_value {
    margin-bottom: 16px;
}
.badge_select_value label span{
    color: rgba(0, 0, 0, 0.90);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}
.badge_select_value label {
    display: flex;
    gap: 6px;
    padding: 10px;
    border-radius: 4px;
    background: #FAFAFA;
}
.clear_klema_filters {
    display: flex;
    justify-content: flex-end;
}
.clear_klema_filter {
    display: flex;
    align-items: center;
}
.left_row {
    display: flex;
    gap: 10px;
}
.table_top_history {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.back_filter_link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
}
.back_filter_link_top {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.sub_group_select {
    padding: 12px 16px;
    width: 200px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.content_header_row {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
</style>